import { Pipe, PipeTransform } from '@angular/core';
import { MemberSubmission } from '../../../models/submissions/member-submission';
import { SubmissionStatusIdEnum } from '../../../models/enum/shared/submission-status-id.enum';
import * as moment from 'moment';
import { SubmissionUtils } from '../../../utils/submission-utils';
import { IpEmployerSubmission } from '../../../models/submissions/employer-submissions/ip-employer-submission';
import { EpEmployerSubmission } from '../../../models/submissions/employer-submissions/ep-employer-submission';

@Pipe({
  name: 'submissionStatusDateString',
  standalone: true
})
export class SubmissionStatusDateStringPipe implements PipeTransform {
  transform(
    submission: MemberSubmission | IpEmployerSubmission | EpEmployerSubmission,
    dateFormat: string = 'MMM D, YYYY'
  ): string {
    const relevantDate = SubmissionUtils.getRelevantDate(submission);
    const formattedDate = this.getFormattedDate(relevantDate, dateFormat);
    if (!(submission instanceof EpEmployerSubmission) && submission.isApproved()) {
      return $localize`Approved On ${formattedDate}`;
    }
    if (!(submission instanceof EpEmployerSubmission) && submission.isRejected()) {
      return $localize`Rejected On ${formattedDate}`;
    }
    if (submission instanceof EpEmployerSubmission && submission.statusId === SubmissionStatusIdEnum.Completed) {
      return $localize`Submitted On ${formattedDate}`;
    }
    switch (submission.statusId) {
      case SubmissionStatusIdEnum.Pending:
        return $localize`Started On ${formattedDate}`;
      case SubmissionStatusIdEnum.Cancelled:
        return $localize`Cancelled On ${formattedDate}`;
      case SubmissionStatusIdEnum.Completed:
        return $localize`Completed On ${formattedDate}`;
      case SubmissionStatusIdEnum.Submitted:
      case SubmissionStatusIdEnum.InReview:
        return $localize`Submitted On ${formattedDate}`;
      default:
        return '';
    }
  }

  private getFormattedDate(date: string | Date | null, dateFormat: string): string {
    return moment(date).format(dateFormat);
  }
}
